<div
  id="message"
  class="alert"
  [ngClass]="messageClass"
  style="margin-bottom: 1em"
  #alertMsg
  (transitionend)="onTransitionEnd($event)"
>
  {{ message()?.message }}
</div>
